export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Instalación/Grupo\",\n    \"label_other\": \"{{count}} Instalación/Grupo\"\n}\n"